// ============================================================
// DefenceChainChart - P(avoid N hits) bar chart with expected line.
// ============================================================
import BarChart from './BarChart';
import type { DefenceChainDistribution } from '../../engine/defenceProbability';

interface Props {
  data: DefenceChainDistribution;
}

export default function DefenceChainChart({ data }: Props) {
  const bars = data.avoidedDistribution.map((p, i) => ({
    label: String(i),
    value: p,
    color: '#c4a35a',
  }));

  return (
    <BarChart
      data={bars}
      barColor="#c4a35a"
      showValues
      formatValue={(v) => (v * 100).toFixed(0) + '%'}
      annotationValue={
        data.expectedAvoided < data.avoidedDistribution.length
          ? data.expectedAvoided / (data.avoidedDistribution.length - 1 || 1)
          : undefined
      }
      annotationLabel={`E[avoided] ${data.expectedAvoided.toFixed(1)}`}
      maxValue={1}
    />
  );
}
